<template>
  <div class="card">
    <div class="card-header">
      <p class="card-header-title">
        <span class="skeleton-line short" />
      </p>
    </div>
    <div class="card-content p-0">
      <table class="table is-fullwidth mb-0">
        <thead>
          <tr>
            <th class="col-number"><span class="skeleton-line" /></th>
            <th><span class="skeleton-line" /></th>
            <th class="col-type"><span class="skeleton-line" /></th>
            <th class="col-date"><span class="skeleton-line" /></th>
            <th class="col-amount"><span class="skeleton-line" /></th>
            <th class="col-comment"><span class="skeleton-line" /></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in 4" :key="i">
            <td class="col-number"><span class="skeleton-line" /></td>
            <td>
              <span
                class="skeleton-line"
                :style="{ width: rowWidths[i - 1] }"
              />
            </td>
            <td class="col-type"><span class="skeleton-line type-skel" /></td>
            <td class="col-date"><span class="skeleton-line" /></td>
            <td class="col-amount"><span class="skeleton-line" /></td>
            <td class="col-comment">
              <span
                class="skeleton-line"
                :style="{ width: commentWidths[i - 1] }"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts" setup>
const rowWidths = ['85%', '60%', '75%', '90%'];
const commentWidths = ['70%', '40%', '55%', '80%'];
</script>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.skeleton-line {
  display: block;
  background: linear-gradient(
    90deg,
    #e2e8f0 0%,
    #eef2f6 30%,
    #f1f5f9 50%,
    #eef2f6 70%,
    #e2e8f0 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.6s ease-in-out infinite;
  border-radius: 4px;
  height: 14px;
  width: 100%;
}

.skeleton-line.short {
  width: 12rem;
}

.type-skel {
  width: 3.5rem;
}

.card-header {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.table th,
.table td {
  padding: 0.75rem 1rem;
  vertical-align: middle;
}

.col-number {
  width: 6rem;
}

.col-type {
  width: 7rem;
}

.col-date {
  width: 10rem;
}

.col-amount {
  width: 11rem;
  text-align: right;
}

.col-comment {
  width: 14rem;
}
</style>
